// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4044":"912e030f","9628":"5c0f1342"}[chunkId] + ".chunk.css";
};